export default "__VITE_ASSET__DSlcVqQD__"